import { render, staticRenderFns } from "./StepCredentialsButton.vue?vue&type=template&id=1fa2c20e"
import script from "./StepCredentialsButton.vue?vue&type=script&lang=js"
export * from "./StepCredentialsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports